import React from 'react'
import $ from "jquery";

import { Helmet } from "react-helmet";

import {RotatingLines} from "react-loader-spinner";

import InnerHTML from "dangerously-set-html-content";
import {InView} from "react-intersection-observer";

import RelatedProduct from '../components/Product'
import ProductDetail from "../components/ProductDetail";
import { ShadowRoot } from '../components/ShadowRoot';

import CollapsibleList from '../components/CollapsibleList';

import { getImageUrl, Sizes } from '../components/blocks/editable/Img'
import ShareModal from '../components/modal/ShareModal'
import ProductSettingsModal from '../components/modal/ProductSettingsModal'

import General from '../utils/General'
import ScriptCache from '../utils/ScriptCache'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Cart from '../utils/Cart'

import MockData from "../utils/MockData";
import Event from "../utils/Event";
import Backend from "../utils/Backend";
import BadgeBlock from '../components/BadgeBlock';
import DefaultData from "../utils/DefaultData";

export default class Product extends React.Component {
  constructor(props){
    super(props)

    let productSlug = window.location.pathname.split("/").pop()

    // key is incremented as the slider js functions
    // overwrite the html so we want to refresh it
    // as React is out of sync when
    // adding/editing/deleting the images
    this.state = {
      key: 0,
      loading: true,
      quantity: 1,
      variant: [],
      customMessage: [],
      editable: props.editable,
      website: window.CURRENT_WEBSITE,
      options: [],
      productSlug,
      campaignProductId: General.getUrlParameter("campaignProductId"),
      dropdown: General.getUrlParameter("dropdown"),
      showProductSettingsModal : false,
      indexLoaded: false,
      purchaseOption: "single",
      frequency: null,
      subscribeAndSaveSettings: window.CURRENT_WEBSITE?.extra?.subscribe_save_settings || {
        textColor: 'rgb(102, 102, 102)',
        selectedTextColor: 'rgb(102, 102, 102)',
        backgroundColor: 'rgb(252, 252, 252)',
        selectedBackgroundColor: 'rgb(252, 252, 252)',
        borderColor: 'rgb(236, 236, 236)',
        selectedBorderColor: 'rgb(236, 236, 236)',
        borderStyle: '6px',
        oneTimeIcon: '',
        subscribeIcon: '',
        activeIconTab: 'subscribe',
        discountFormat: 'price',
        useCustomIcon: false,
      }
    }

    this.quantityInput = React.createRef()

    this._updateWebsite = General.debounce(
      () => {
        Backend.updateWebsite({
          slug: this.state.website.slug,
          extra: this.state.website.extra,
          checkout_type: this.state.website.checkout_type,
        });
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup()
    if (this.state.editable) {
      Backend.getPages(window.CURRENT_WEBSITE_ID);
      Backend.getCCPages();
    }
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _setup(){
    let {
      productSlug
    } = this.state

    this.setState({loading: true})
    Backend.getProducts(productSlug).then(products => {
      let product = products[0]
      let variant = Cart.selectDefaultVariant(product)
      let variantOptions = Cart.getOptions(product)
      let customMessageOptions = Cart.getCustomMessageOptions(product)
      let purchaseOption = product.defaultProduct === 'RECURRING' ? 'recurring' : 'single'
      if(product.recurringProductId){
        Backend.getProducts(product.recurringProductId).then(subscribeAndSaveProducts => {
          let subscribeAndSaveProduct = subscribeAndSaveProducts[0]
          let subscribeAndSaveVariantOptions = Cart.getOptions(subscribeAndSaveProduct)
          this.setState({customMessageOptions, variant, variantOptions, product, purchaseOption, loading: false, subscribeAndSaveProduct, subscribeAndSaveVariantOptions}, () => this._loadJs())
        })
      }else{
        this.setState({customMessageOptions, variant, variantOptions, product, purchaseOption, loading: false}, () => this._loadJs())
      }
    }).catch(e => {
      Notify.error(e.message)
      this.setState({loading: false})
    })
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 500)
    this._mobileAddToCartStickyBtn();
  }

  _update(website, callback) {
    this.setState({ website }, () => {
      if (callback) {
        callback();
      }
      this._updateWebsite();
    });
  }

  _mobileAddToCartStickyBtn(){
    try {
      setTimeout(() => {
        var elementButton = $('.sticky-buttons-wrapper');
        var elementLiveChat = $('div.live-chat.main-container .live-chat-icon');
        // checks the window is less than 768px
        if (elementButton.length && $(window).width() < 768) {

          var distance = elementButton.offset().top + elementButton.outerHeight();

          $(window).scroll(function () {

            if ($(window).scrollTop() >= distance) {

              if (!elementButton.hasClass("affix")) {
                elementButton.addClass("affix");
              }

              if (elementLiveChat.length && !elementLiveChat.hasClass("up-from-btm")) {
                elementLiveChat.addClass("up-from-btm");
              }

            } else {

              if (elementButton.hasClass("affix")) {
                elementButton.removeClass("affix");
              }

              if (elementLiveChat.length && elementLiveChat.hasClass("up-from-btm")) {
                elementLiveChat.removeClass("up-from-btm");
              }

            }

        });

        }
      }, 1000)
    }
    catch (err) {
      console.error(err.message);
    }
  }

  async _onDashboardClicked() {
    this.setState({savingPage: true})
    Backend.generateThumbnail();
    await Backend.savePage();
    window.open(`${window.General.ApplicationUrl}/editfunnel/${window.CURRENT_WEBSITE.funnel_reference_id}`, "_self");
  }

  updateSubscribeAndSaveSettings = (keyOrObject, value) => {
    this.setState(prev => {
      const { website } = this.state;
      const updatedSettings = {
        ...prev.subscribeAndSaveSettings,
        ...(typeof keyOrObject === 'object'
          ? keyOrObject
          : { [keyOrObject]: value })
      };
      if(!website.extra){
        website.extra = {subscribe_save_settings: null}
      }
      website.extra.subscribe_save_settings = updatedSettings;
      this._update(website)
      return { subscribeAndSaveSettings: updatedSettings };
    });
  };

  _renderProductSettingsButton() {
    let {
      editable,
      savingPage
    } = this.state;

    if (!editable) {
      return;
    }

    let className = "btn-fixed-left-container ignore-user-set-font";

    return (
      <div className={className}>

        <div className="d-flex">
          <button
            className="btn"
            title="Back to Funnel"
            onClick={() => this._onDashboardClicked()}
          >
            <span className="btn__text">
              {
                savingPage ?
                  <RotatingLines
                    height={24}
                    width={"24"}
                    strokeColor={"#ffffff"}
                  />
                  :
                  <span className="material-icons">arrow_back_ios_new_outlined</span>
              }
              <span className="slide-text">Back to Funnel</span>
            </span>
          </button>
        </div>

        {/* Starts : Button 01 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({ showProductSettingsModal: true })}
          >
            <span className="btn__text">
              <span class="material-icons">brush_outline</span>
              <span class="slide-text">Product Settings</span>
            </span>
          </a>
        </div>
        {/* End : Button 01 */}

      </div>
    );
  }

  _renderMeta(){
    let {
      product,
      website
    } = this.state

    if(product == null){
      return null
    }

    let favIconUrl = website.favicon ? website.favicon.original : "/favicon.ico"

    return (
      <Helmet>
        <title>{`${product.productName} | ${website.name}`}</title>
        <meta name="description" content={ product.productDescription} />
        <meta name="keywords" content={ product.productTags || website.keywords } />
        <link rel="icon" href={ favIconUrl }/>
        <meta property="og:title" content={ product.productName }/>
        <meta property="og:image" content={ product.imageUrl }/>
        <meta property="og:description" content={ product.productDescription }/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={ window.location.href }/>
        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content={ window.location.href }/>
        <meta property="twitter:title" content={ product.productName }/>
        <meta property="twitter:description" content={ product.productDescription }/>
        <meta property="twitter:image" content={ product.imageUrl }/>
      </Helmet>
    )
  }

  _renderLoading(){
    return (
      <div className="main-container page product">
        {/* starts, main product section  */}
        <section className="switchable sticky-sidebars page-product pt-0 pb-4 pt-md-5">
          <div className="container">
            <div className="row justify-content-around">
              {/* starts, column right, sticky sidebar  */}
              <div className="col-md-5">
                <div className="sidebar__inner">
                  <h2 className="shimmer" style={{ height: 41}}/>
                  <div class="shimmer" style={{ width: 100, height: 26}} />
                  <div>
                    <div class="sizes my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="items btn_horizontal">
                        <div class="item shimmer" style={{ width: 84, height: 39}} />
                        <div class="item shimmer" style={{ width: 84, height: 39}} />
                      </div>
                    </div>
                    <div class="my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="shimmer" style={{ height: 45}} />
                    </div>
                    <div class="my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="shimmer" style={{ height: 45}} />
                    </div>
                    <div class="row quan-cart my-38px mx-0">
                      <div class="col-md-4 pl-0">
                        <div class="shimmer" style={{ width: 102, height: 45}} />
                      </div>
                      <div class="col-md-8 p-md-0">
                        <div class="shimmer" style={{ height: 45}} />
                      </div>
                    </div>
                    <span class="link-share block type--fine-print text-center my-38px d-flex justify-content-center align-items-center">
                      <span class="r-box material-icons"><div class="shimmer" style={{ width: 22, height: 22}} /></span>
                      <a href="javascript:void(0)" class="text-uppercase type--underline link--primary">
                        <div class="shimmer" style={{ width: 124, height: 22}} />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              {/* end, column right, sticky sidebar  */}
              {/* starts, column left  */}
              <div className="col-md-7">
                 {/* starts, slider  */}
                 <div className="shimmer slider-product-main slider border--round boxed--border"/>
                  {/* end, slider  */}
                  <section class="switchable p-0">
                    <div class="container">
                      <div class="row justify-content-between">
                        <div class="col-md-12 col-lg-12 p-0">
                          <h2><div class="shimmer" style={{ height: 45}} /></h2>
                          <div class="lead pre"><div class="shimmer" style={{ height: 135}} /></div>
                        </div>
                      </div>
                    </div>
                  </section>
              </div>
              {/* end, column left  */}
            </div>
          </div>
        </section>
        {/* end, main product section  */}
      </div>
    )
  }

  render(){
    let {
      editable,
      product,
      website,
      variant,
      variantOptions,
      loading,
      customMessageOptions,
      subscribeAndSaveProduct,
      subscribeAndSaveVariantOptions,
      subscribeAndSaveSettings
    } = this.state

    if(loading){
      return (
        <>
          { this._renderLoading() }
        </>
      )
    }

    if(!product || !variantOptions){
      return null
    }

    const evenColumnWidth = website?.extra?.product_page_settings?.column_width === "even"

    let layoutOrder = website.extra?.product_page_settings?.layoutOrder;
    if (!Array.isArray(layoutOrder) || layoutOrder.length === 0) {
      layoutOrder = [...DefaultData.PRODUCT_PAGE_LAYOUT];
    }

    return (
      <>
        <div className="main-container page product">
          { this._renderMeta() }
          {/* starts, main product section  */}
          <section className="switchable sticky-sidebars page-product pt-0 pb-4 pt-md-5">
            <div className="container">
              <ProductDetail
                product={product}
                variant={variant}
                variantOptions={variantOptions}
                subscribeAndSaveProduct={subscribeAndSaveProduct}
                subscribeAndSaveVariantOptions={subscribeAndSaveVariantOptions}
                subscribeAndSaveSettings={subscribeAndSaveSettings}
                customMessageOptions={customMessageOptions}
                editable={editable}
                extra={website.extra?.product_page_settings}
                evenColumnWidth={evenColumnWidth}
                layoutOrder={layoutOrder}
                onAddToCartPressed={(
                  product,
                  variant = null,
                  customMessage =null,
                  quantity = 1,
                  frequency = null
                ) => {
                  this.props.onAddToCartPressed(product, variant, customMessage, quantity, frequency);
                }}
              />
            </div>
          </section>
          {/* end, main product section  */}

          {/*{ this._renderRelatedProducts(product) }*/}
        </div>
        {
          website.extra.product_page_settings.product_page_html &&
          <>
            {
              website.extra.product_page_settings.product_page_html_lazy_load &&
              <InView
                triggerOnce={true}
              >
                {({ inView, ref, entry }) => (
                  <div ref={ref}>
                    { inView &&
                      <InnerHTML html={website.extra.product_page_settings.product_page_html}/>
                    }
                  </div>
                )}
              </InView>
            }

            {
              !website.extra.product_page_settings.product_page_html_lazy_load &&
              <section className="block-54 text-center">
                <div className="container">
                  <InnerHTML html={website.extra.product_page_settings.product_page_html}/>
                </div>
              </section>
            }
          </>

        }
        {this._renderProductSettingsButton()}
        <ProductSettingsModal
          show={this.state.showProductSettingsModal}
          website={website}
          onCheckoutTypeUpdated={(checkoutType) => {
            website.checkout_type = checkoutType
            this._update(website)
          }}
          onUpdated={(data) => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = data
            this._update(website)
          }}
          subscribeAndSaveSettings={this.state.subscribeAndSaveSettings}
          updateSubscribeAndSaveSettings={this.updateSubscribeAndSaveSettings}
          onHide={() => this.setState({showProductSettingsModal: false})}
        />
        <div id="notification-container" class="text-center">
          <div id="notification-content"></div>
        </div>
      </>
    )
  }
}
